(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tbc-ship-bar-pdp"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tbc-ship-bar')) {
    class TbcShipBar extends HTMLElement {
      connectedCallback() {
        this.onCartUpdate = (event) => this.refresh(event);
        document.addEventListener('shopify:cart:lines-update', this.onCartUpdate);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:cart:lines-update', this.onCartUpdate);
      }

      async refresh(event) {
        // The event fires when the request starts; wait for it to finish before reading the cart
        const pending = event && (event.promise || (event.detail && event.detail.promise));
        try {
          if (pending) await pending;
          else await new Promise((resolve) => setTimeout(resolve, 800));
        } catch (error) {}

        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          const cart = await response.json();
          this.update(cart.total_price, cart.item_count);
        } catch (error) {}
      }

      update(total, itemCount) {
        const threshold = Number(this.dataset.threshold);
        const remaining = threshold - total;
        const money = new Intl.NumberFormat('en-CA', { style: 'currency', currency: this.dataset.currency || 'CAD' });

        this.querySelector('[data-text]').innerHTML =
          remaining > 0
            ? `You're <strong>${money.format(remaining / 100)}</strong> away from <strong>free shipping</strong>`
            : `You've unlocked <strong>free shipping</strong>!`;
        this.querySelector('[data-fill]').style.width = `${Math.min(100, Math.floor((total * 100) / threshold))}%`;
        this.classList.toggle('tbc-ship-bar--unlocked', remaining <= 0);
        this.hidden = itemCount === 0;
      }
    }

    customElements.define('tbc-ship-bar', TbcShipBar);
  }
  } catch(e) { console.error(e); }
})();

})();
